import React, { useRef } from 'react';
import styles from './Chatbot.module.scss';
import ChatBody from './ChatBody';
import ChatFooter from './ChatFooter';

interface MobileChatProps {
    setIsChatVisible: React.Dispatch<React.SetStateAction<boolean>>;
}

const MobileChat: React.FC<MobileChatProps> = ({ setIsChatVisible }) => {
    const chatWindowRef = useRef<HTMLDivElement | null>(null);

    const handleTouchStart = (e: React.TouchEvent) => {
        const startY = e.touches[0].clientY;
        const startHeight = chatWindowRef.current?.offsetHeight || 0;

        const handleTouchMove = (moveEvent: TouchEvent) => {
            const currentY = moveEvent.touches[0].clientY;
            const newHeight = startHeight - (currentY - startY);
            if (chatWindowRef.current) {
                chatWindowRef.current.style.height = `${newHeight}px`;
            }
        };

        const handleTouchEnd = () => {
            if (chatWindowRef.current) {
                const currentHeight = chatWindowRef.current.offsetHeight;
                const viewportHeight = window.innerHeight;
                const halfHeight = viewportHeight * 0.5;
                const maxHeight = viewportHeight * 0.9;

                if (currentHeight < halfHeight * 0.7) {
                    chatWindowRef.current.style.height = '0';
                    setIsChatVisible(false);
                } else if (currentHeight < halfHeight * 1.3) {
                    chatWindowRef.current.style.height = `${halfHeight}px`;
                } else {
                    chatWindowRef.current.style.height = `${maxHeight}px`;
                }
            }
            window.removeEventListener('touchmove', handleTouchMove);
            window.removeEventListener('touchend', handleTouchEnd);
        };

        window.addEventListener('touchmove', handleTouchMove);
        window.addEventListener('touchend', handleTouchEnd);
    };

    return (
        <div ref={chatWindowRef} className={styles.chatWindowMobile} style={{ height: '50%' }}>
            <div className={styles.chatHeaderMobile} onTouchStart={handleTouchStart}>
                <div className={styles.resizeHandleMobile} />
                <div className={styles.chatHeader}>
                    <h2 className={styles.chatHeaderTitle}>DEU·PA Assistent</h2>
                </div>
            </div>
            <ChatBody />
            <ChatFooter />
        </div>
    );
};

export default MobileChat;
